// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomSelect_container__LICwd"};